import React, { useState } from "react";
import LeftBar from "../common/LeftBar";
import TopBar from "../common/TopBar";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const toggleSidebarVisibility = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  return (
    <div className={`admin-layout ${isSidebarVisible ? "sidebar-open" : "sidebar-closed"}`}>
      <div className="container-fluid">
        <div className="row flex-nowrap">
          <div className={`col-auto col-xl-2 px-0 ${isSidebarVisible ? "" : "collapsed-sidebar"}`}>
            <LeftBar isVisible={isSidebarVisible} />
          </div>
          <div className="col-10 p-0">
            <div className="caspera_content">
              <TopBar toggleSidebar={toggleSidebarVisibility} isSidebarVisible={isSidebarVisible} />
              <div className="caspera_data">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;

